/* eslint-disable import/no-extraneous-dependencies */
import { Server } from 'miragejs';

import account from './account';
import auth from './auth';
import businessPhone from './businessPhone';
import callRescueTestCall from './callRescueTestCall';
import industry from './industry';
import parentAccount from './parentAccount';
import user from './user';
import wlDevices from './wlDevices';

function routes(this: Server): void {
  this.timing = 100;
  this.namespace = 'api';
  this.urlPrefix = 'http://localhost:3000';
  account(this);
  user(this);
  auth(this);
  industry(this);
  callRescueTestCall(this);
  businessPhone(this);
  parentAccount(this);
  wlDevices(this);
}

export default routes;
